import { render } from "./Brands.vue?vue&type=template&id=db1018f4&scoped=true"
import script from "./Brands.vue?vue&type=script&lang=js"
export * from "./Brands.vue?vue&type=script&lang=js"

import "./Brands.vue?vue&type=style&index=0&id=db1018f4&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\bdroyelculture-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db1018f4"]])

export default __exports__